import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=45c596d0&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=45c596d0&prod&scoped=true&lang=css"
import style1 from "./QuillEditor.vue?vue&type=style&index=1&id=45c596d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c596d0",
  null
  
)

export default component.exports